import { render, staticRenderFns } from "./PurchasedPackages.vue?vue&type=template&id=3e9823d5&scoped=true"
import script from "./PurchasedPackages.vue?vue&type=script&lang=js"
export * from "./PurchasedPackages.vue?vue&type=script&lang=js"
import style0 from "./PurchasedPackages.vue?vue&type=style&index=0&id=3e9823d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9823d5",
  null
  
)

export default component.exports